import { Component, Input, OnInit } from '@angular/core';
import { Inject } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth.service';
import { NoWhiteSpaceValidator } from 'src/app/core/shared/validators/whitespace-validator';
import {
  AddUpdateApplication,
  ApproveApplication,
  DeleteApplication,
} from '../../../../shared/actions/application.actions';
import { Application } from '../../../models/application.model';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
@Component({
  selector: 'app-application-modal',
  templateUrl: './application-modal.component.html',
  styleUrls: ['./application-modal.component.scss'],
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, MatSnackBarModule, MatFormField, MatLabel, MatInput, MatError, MatIcon, MatButton, MatIconButton],
})
export class ApplicationModalComponent implements OnInit {
  @Input() public application!: Application;
  @Input() public formMode = 'New';
  @Input() public editApplication = false;
  @Input() public admin = false;
  public approve!: boolean;
  private formSubscription: Subscription = new Subscription();
  entryForm!: FormGroup;
  error: string | undefined;

  constructor(
    @Inject(NgbModal) public modalService: NgbModal,
    @Inject(NgbActiveModal) public activeModal: NgbActiveModal,
    @Inject(Store) public store: Store,
    public router: Router,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    @Inject(MatSnackBar) private snackBar: MatSnackBar
  ) {
    this.createForm();
  }

  ngOnInit() {
    const application = this.application;
    if (application) {
      this.entryForm.patchValue({
        application_name: application.application_name,
        Description: application.Description,
        approved: application.approved,
      });
      this.approve = application.approved;
      this.editApplication = true;
      //this.entryForm.get("ApplicationName")?.disable();
    } else {
      this.approve = false;
      this.editApplication = false;
    }
  }

  //   // Handle Create  update button click
  onCreate(): void {
    this.entryForm.controls['application_name'].setValue(
      this.entryForm.controls['application_name'].value.trim()
    );
    const appname = this.entryForm.controls['application_name'].value;

    if (this.editApplication) {
      this.entryForm.controls['approved'].setValue(this.application.approved);
    } else {
      this.entryForm.controls['approved'].setValue(false);
    }
    this.authService.getCurrentUser().then((user) => {
      this.formSubscription.add(
        this.store
          .dispatch(
            new AddUpdateApplication(
              user.username.replace('DraexlmaierAzureAD_', ''),
              this.entryForm.value
            )
          )
          .subscribe(
            (resp: any) => {
              this.activeModal.close();
              this.showSnackBar('Application added successfully!', false);
            },
            (error) => {
              this.activeModal.close();
              this.showSnackBar(
                'An error occurred:' + error.error.message,
                true
              );
            }
          )
      );
    });
  }

  openConfirmModal(message: string) {
    // Open modal form component
    const modalRef = this.modalService.open(ConfirmationModalComponent, {});
    modalRef.componentInstance.message = message;
    modalRef.result.then((event) => {
      if (event == 'confirm') {
        this.onDelete();
      }
    });
  }
  // Handle Create button click

  OnApprove(): void {
    const application = this.application;
    application.approved = true;
    this.store.dispatch(new ApproveApplication(application)).subscribe(
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      (resp: any) => {
        this.activeModal.close();
        this.showSnackBar('The application has been approved!', false);
      },
      (error) => {
        this.activeModal.close();
        this.showSnackBar('An error occurred:' + error.error.message, true);
      }
    );
  }

  // Handle Delete button click
  onDelete() {
    this.store
      .dispatch(
        new DeleteApplication(this.entryForm.controls['application_name'].value)
      )
      .subscribe(
        (resp: any) => {
          this.activeModal.close();
          this.showSnackBar(
            'The application has been successfully deleted!!',
            false
          );
        },
        (error) => {
          this.activeModal.close();
          this.showSnackBar('An error occurred:' + error.error.message, true);
        }
      );
  }

  view() {
    this.router.navigate([
      '/secure/developer/application-menu',
      { applicationName: this.application.application_name },
    ]);
    this.activeModal.close('view');
  }

  // reactive form
  private createForm() {
    this.entryForm = this.formBuilder.group({
      application_name: new FormControl('', [
        Validators.required,
        NoWhiteSpaceValidator.cannotContainSpace,
      ]),
      Description: new FormControl('', [Validators.required]),
      approved: [''],
    });
  }

  get f() {
    return this.entryForm.controls;
  }

  showSnackBar(message: string, isError: boolean): void {
    this.snackBar.open(message, 'Close', {
      duration: 3000, // Duration in milliseconds
      panelClass: isError ? 'error-snackbar' : 'success-snackbar', // Custom CSS classes for styling
    });
  }

  clearForm() {
    this.entryForm.reset();
  }
}
